
import BrifecaseTimer from "../../../assets/duotone/BrifecaseTimer.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function BrifecaseTimerIcon({ className, dataTestid = "BrifecaseTimerIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <BrifecaseTimer data-testid={dataTestid} className={classes} {...rest} />
  );
}
